import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-label",
  styleUrls: ["./label.component.scss"],
  template: `
    <label [for]="formControlName" class="form-label" [ngClass]="className">
      {{ label }}
      <span *ngIf="required" class="field-label-required">&#42;</span>
    </label>
  `,
})
export class LabelComponent implements OnInit {
  @Input() className: string = "";
  @Input() label: string;
  @Input() required: boolean = false;
  @Input() formControlName: string;

  constructor() {}

  ngOnInit(): void {}
}
